export const endorsementOptions = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];
